function calculateFinalAmount(rechargeAmount, mintPercentage) {
  
    if (typeof rechargeAmount !== 'number' || typeof mintPercentage !== 'number') {
      throw new Error('Recharge amount and mint percentage must be numbers.');
    }
  
    if (mintPercentage < 0) {
      throw new Error('Mint percentage cannot be negative.');
    }
  
    if (mintPercentage === 0) {
      return null; // Or throw an error if you prefer
    }
  
    const finalAmount = (rechargeAmount * 100) / mintPercentage;
    return finalAmount;
  }
  
  export default calculateFinalAmount; // Make the function available for use in your components
  